import { ICardSignatureUI } from "./types"

import { Button, Divider, Drawer, Flex, Input, Loader, Textarea } from "@ui/index"
import { IconCalendar, IconClearClose, IconSelect } from "@img/icons"
import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'

import { SelectDate } from "@primitive/calendar"
import { getInputButton } from "@primitive/getInputButton"
import { DictSelectorContainer } from "@smart/dictSelector/ui.container"

import css from './ui.module.scss'


/** Анкета - Договор на подпись */
export const CardSignatureUI = ({ 
    isOpen, contractNumber, dataBase, fieldsError, isLoadingCard, isDisableBtnSave,
    txtStatusID, txtStatusName, txtDateNextCall, txtTimeNextCall, txtComment,
    handleBtnSave, handleBtnClose,
}: ICardSignatureUI) => {
    const siteLogo = dataBase === 'yaskill'
        ? {src: logoYaSkill, name: 'YaSkill'}
        : dataBase === 'modern_academy'
            ? {src: logoModSkill, name: 'ModSkill'}
            : null

    return <>
        <Drawer isOpen={isOpen} placement='bottom' size='100%'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <header>
                        <Flex gap='6px' flexDirection='row' alignItems='center'>
                            {siteLogo && <img className={css['header_logo']} src={siteLogo.src} alt={`Логотип ${siteLogo.name}`} />}
                            <h4>Анкета договора № {contractNumber}</h4>
                        </Flex>
                    </header>

                    
                    <Button variant='icon' size='md' isDisabled={isLoadingCard} onClick={handleBtnClose}>
                        <IconClearClose />
                    </Button>
                    
                </Flex>

                <Flex gap='4px' className='drawer_container-body_bottom_panel'>
                    <Loader isOpen={isLoadingCard} backdrop={true} color="var(--color_txt_accent)" title="Загрузка данных..." />

                    <Flex gap='20px' className='drawer_container-content'>
                        <Flex gap="5px">
                            <Divider gap="6px" prefix={<h4>Основные данные</h4>} />

                            <Flex gap="15px">
                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.statusName ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Статус договора <p className="pulse"></p></Flex>
                                        <Input placeholder="Статус договора" isReadOnly paddingRight='2px' {...txtStatusName} suffix={
                                            <DictSelectorContainer dictName="signatureStatus" onSelect={(data) => {
                                                txtStatusID.setValue(Number(data.id))
                                                txtStatusName.setValue(data.name)
                                            }}><Button size="sm" variant="iconInput"><IconSelect /></Button></DictSelectorContainer>
                                        }/>
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.dateNextCall ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Дата отложенного звонка {txtStatusID.value === 2 && <p className="pulse"></p>}</Flex>
                                        <Input placeholder="Дата отложенного звонка" isDisabled={txtStatusID.value !== 2} 
                                            paddingRight='2px' type='mask' mask='99.99.2099' maskChar="" {...txtDateNextCall} 
                                            
                                            suffix={<>
                                                {txtDateNextCall.value && getInputButton('clear', txtDateNextCall.reset)}
                                                <SelectDate currentDate={txtDateNextCall.value} onSelect={(date) => { txtDateNextCall.setValue(date) }}>
                                                    <Button size="sm" variant="iconInput">
                                                        <IconCalendar />
                                                    </Button>
                                                </SelectDate>
                                            </>} 
                                        />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.timeNextCall ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex flexDirection="row" className="input_header">Время отложенного звонка</Flex>
                                        <Input placeholder="Время отложенного звонка" isDisabled={txtStatusID.value !== 2} 
                                            paddingRight='2px' type='mask' mask='99:99:00' maskChar=""
                                            suffix={txtTimeNextCall.value && getInputButton('clear', txtTimeNextCall.reset)} {...txtTimeNextCall}
                                        />
                                    </Flex>
                                </Flex>

                                <Flex flexGrow={1}>
                                    <Flex flexDirection="row" className="input_header">Комментарий</Flex>
                                    <Textarea placeholder="Комментарий" rows={5} value={txtComment.value} onChange={(e) => txtComment.setValue(e.target.value)} />
                                </Flex>
                            </Flex>
                        </Flex>
                    </Flex>

                    <Divider />

                    <Flex flexWrap='wrap' flexDirection='row' gap='4px'>
                        <Flex flexDirection='row' gap='4px' justifyContent="flex-start">
                            <Button flexGrow={1} padding='0 10px' 
                                isDisabled={isDisableBtnSave.value || isLoadingCard}
                                onClick={() => handleBtnSave(true)}
                            >Сохранить и закрыть</Button>

                            <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoadingCard} 
                                onClick={() => handleBtnSave(false)}
                            >Сохранить</Button>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Drawer>
    </>
}